import BaseCrudRepository from '@/repositories/BaseCrudRepository';
import HttpClient from '@/util/http/HttpClient';
import WeeklySign from '@/repositories/data/weeklysign/WeeklySign';

export default class WeeklySignRepository extends BaseCrudRepository<number, WeeklySign, WeeklySign> {
    constructor(client: HttpClient) {
        super(client, 'rest/admin/weekly-sign/');
    }
}
